<template>
    <zen-one
        :showuserinfo="false"
        :title="'Kutipan Pejabat Daerah'"
    >
        <z-animate-number value="29"></z-animate-number>
        <GraphBarKutipan/>
        <w-divider class="my6"></w-divider>
        <w-flex class="grow justify-space-betweenx basis-zero">
            <w-card class="mb3 mr3">
                <table
                class="table-dashboard"
                width="100%"
                >
                <thead>
                    <tr style="background-color:rgb(195, 147, 225); color:black;">
                        <td>Id</td>
                        <td>Cara Bayaran</td>
                        <td>Pendidikan (RM)</td>
                    </tr>
                </thead>
                <tbody >
                    <tr v-for="(cua,index) in caraBayar">
                        <!-- <div v-if="cua.length !='0'"> -->
                        <td>{{ index + 1}}</td>
                        <td>{{ cua.jenis }}</td>
                        <td>{{ cua.amaun }}</td>
                    </tr>
                </tbody>
            </table>
            </w-card>
        </w-flex>

        <!-- <w-flex class="grow justify-space-betweenx basis-zero"> -->
            <w-card class="mb3 mr3">
                <fusioncharts
                    :type="chart12.type"
                    :width="chart12.width"
                    :height="chart12.height"
                    :dataformat="chart12.dataFormat"
                    :dataSource="chart12.dataSource"
                >
                </fusioncharts>
            </w-card>
        <!-- </w-flex> -->
        <!-- <w-flex class="grow justify-space-betweenx basis-zero"> -->
            <w-card class="mb3 mr3">
                <fusioncharts
                    :type="chart13.type"
                    :width="chart13.width"
                    :height="chart13.height"
                    :dataformat="chart13.dataFormat"
                    :dataSource="chart13.dataSource"
                >
                </fusioncharts>
            </w-card>
        <!-- </w-flex> -->
        <!-- <w-flex class="grow justify-space-betweenx basis-zero"> -->
            <w-card class="mb3 mr3">
                <fusioncharts
                    :type="chart14.type"
                    :width="chart14.width"
                    :height="chart14.height"
                    :dataformat="chart14.dataFormat"
                    :dataSource="chart14.dataSource"
                >
                </fusioncharts>
            </w-card>
        <!-- </w-flex> -->
    </zen-one>
</template>

<script>
import GraphBarKutipan from "@/Pages/Dashboard/cart-EIS/GraphBarPendidikan.vue";
import Vue3ChartJs from "@j-t-mcc/vue3-chartjs";
import ChartJsPluginDataLabels from "chartjs-plugin-datalabels";

Vue3ChartJs.registerGlobalPlugins([ChartJsPluginDataLabels]);
    export default {
        components:{
            GraphBarKutipan
        },
        data() {
            return {
                bulanLong: new Intl.DateTimeFormat('ms-MY', { month: 'long'}).format(new Date()),
                year: new Intl.DateTimeFormat('ms-MY', { year: 'numeric'}).format(new Date()),
                loading: true,
                apiBaseUrl: process.env.MIX_API_BASE_URL,
                caraBayar:[
                    {jenis: 'E-WALLET (KIOSK)', amaun:'1000.00'},
                    {jenis: 'KAD DEBIT (KIOSK)', amaun:'2000.00'},
                    {jenis: 'KAD DEBIT', amaun:'4000.00'},
                    {jenis: 'WANG TUNAI', amaun:'4000.00'},
                    {jenis: 'DUIT NOW', amaun:'500.00'},
                    {jenis: 'JUMLAH HASIL DARI SEMUA CARA BAYARAN', amaun:'13,500.00'},
                ],
                chart12: {
                    type: "column2d",
                    renderAt: "chart-container",
                    width: "100%",
                    height: "350",
                    dataFormat: "json",
                    dataSource: {
                        chart: {
                            caption: "CARA BAYARAN MENGIKUT TAHUNAN",
                            subcaption: "",
                            xaxisname: "Cara Bayaran",
                            yaxisname: "JUMLAH (RM)",
                            numbersuffix: "",
                            theme: "fusion"
                        },
                        data:
                            [
                                {
                                label: "EWALLET (KIOSK)",
                                value: "290",
                                color: "#FFA500"
                                },
                                {
                                label: "KAD DEBIT(KIOSK)",
                                value: "260",
                                color: "#FFA500"
                                },
                                {
                                label: "KAD DEBIT",
                                value: "180",
                                color: "#FFA500"
                                },
                                {
                                label: "WANG TUNAI",
                                value: "140",
                                color: "#FFA500"
                                },
                                {
                                label: "DUIT NOW",
                                value: "115",
                                color: "#FFA500"
                                },
                                {
                                label: "FPX",
                                value: "100",
                                color: "#FFA500"
                                },
                                {
                                label: "BANK DRAF",
                                value: "30",
                                color: "#FFA500"
                                },
                                {
                                label: "CEK",
                                value: "30",
                                color: "#FFA500"
                                },
                                {
                                label: "IBAYAQ",
                                value: "30",
                                color: "#FFA500"
                                }
                            ],
                        },

                    },
                chart13: {
                    type: "column2d",
                    renderAt: "chart-container",
                    width: "100%",
                    height: "350",
                    dataFormat: "json",
                    dataSource: {
                        chart: {
                            caption: "CARA BAYARAN MENGIKUT BULANAN",
                            subcaption: "",
                            xaxisname: "Cara Bayaran",
                            yaxisname: "JUMLAH (RM)",
                            numbersuffix: "",
                            theme: "fusion"
                        },
                        data:
                            [
                                {
                                label: "EWALLET (KIOSK)",
                                value: "290",
                                color: "purple"
                                },
                                {
                                label: "KAD DEBIT(KIOSK)",
                                value: "260",
                                color: "purple"
                                },
                                {
                                label: "KAD DEBIT",
                                value: "180",
                                color: "purple"
                                },
                                {
                                label: "WANG TUNAI",
                                value: "140",
                                color: "purple"
                                },
                                {
                                label: "DUIT NOW",
                                value: "115",
                                color: "purple"
                                },
                                {
                                label: "FPX",
                                value: "100",
                                color: "purple"
                                },
                                {
                                label: "BANK DRAF",
                                value: "30",
                                color: "purple"
                                },
                                {
                                label: "CEK",
                                value: "30",
                                color: "purple"
                                },
                                {
                                label: "IBAYAQ",
                                value: "30",
                                color: "purple"
                                }
                            ],
                        },

                    },
                chart14: {
                    type: "column2d",
                    renderAt: "chart-container",
                    width: "100%",
                    height: "350",
                    dataFormat: "json",
                    dataSource: {
                        chart: {
                            caption: "CARA BAYARAN MENGIKUT HARIAN",
                            subcaption: "",
                            xaxisname: "Cara Bayaran",
                            yaxisname: "JUMLAH (RM)",
                            numbersuffix: "",
                            theme: "fusion"
                        },
                        data:
                            [
                                {
                                label: "EWALLET (KIOSK)",
                                value: "290"
                                },
                                {
                                label: "KAD DEBIT(KIOSK)",
                                value: "260"
                                },
                                {
                                label: "KAD DEBIT",
                                value: "180"
                                },
                                {
                                label: "WANG TUNAI",
                                value: "140"
                                },
                                {
                                label: "DUIT NOW",
                                value: "115"
                                },
                                {
                                label: "FPX",
                                value: "100"
                                },
                                {
                                label: "BANK DRAF",
                                value: "30"
                                },
                                {
                                label: "CEK",
                                value: "30"
                                },
                                {
                                label: "IBAYAQ",
                                value: "30"
                                }
                            ],
                        },

                    },

            };
        },
        methods: {

        },
        mounted() {

        },
    };
    </script>
<style>
    .hu{
        border-radius: 0.5;
        border:2px purple;
        background-color: rgb(211,189,225);
    }
</style>
